// The LYH Events primary mark: a rounded-square tile, flat brick-600, with the
// letters in Fraunces 700 in Paper. Spec lives in the vault brand kit
// (events/brand/BRAND-KIT.md §5) - this is a faithful build of it, not a redraw.
//
// Three rules from the kit that are easy to break by accident:
//   - FLAT brick below 48px. The Dusk gradient is for 180px+ avatars and covers;
//     four stops inside a small tile turn to mud.
//   - No drop shadow, no glow, no bevel. Losing the shadow is the specific thing
//     the rebrand was for.
//   - 16-32px shows LYH alone. The full nine-letter LYHEVENTS mark needs 48px+,
//     so the top bar tile carries the three letters and the wordmark beside it
//     says the rest.
//
// The letters are live text rather than outlined paths so the tile stays a few
// hundred bytes and reflows with the font. Before Fraunces loads they set in
// Georgia, which is the kit's own designated fallback, so the worst case is
// still on-brand.

const RADIUS_RATIO = 11 / 52

export function BrandMark({
  size = 32,
  className,
  // Letter size in viewBox units. 17 is the kit's value and stays the default,
  // so desktop is untouched. The phone bar passes a larger one (Andrew,
  // 2026-09-07: "the LYH in the logo, make the font size like 2px bigger") now
  // that the nav words moved into the menu and the mark is carrying more of the
  // brand on its own there. +2 RENDERED px at a 32px tile is 2 x 52/32 = 3.25
  // viewBox units, so 20.25.
  letterSize = 17,
}: {
  size?: number
  className?: string
  letterSize?: number
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 52 52"
      className={className}
      role="img"
      aria-label="LYH Events"
    >
      <rect width="52" height="52" rx={52 * RADIUS_RATIO} fill="#7a2e3e" />
      <text
        x="26"
        // Optically centred, not metrically: 'central' sits the cap-height block
        // slightly low in a serif face, so the baseline nudges up a touch.
        y="27"
        textAnchor="middle"
        dominantBaseline="central"
        fill="#fbf8f7"
        fontFamily='"Fraunces", Georgia, "Times New Roman", serif'
        fontWeight="700"
        fontSize={letterSize}
        letterSpacing="0.4"
        style={{ fontVariationSettings: "'opsz' 144, 'SOFT' 40, 'WONK' 1" }}
      >
        LYH
      </text>
    </svg>
  )
}
